import type { AxiosInstance } from 'axios';
import type * as SegmentsInterface from './interfaces/projects.segments.js';

export class SegmentsClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getProjectSegments = (
    data: SegmentsInterface.GetSegmentsByProjectId.Request
  ): Promise<SegmentsInterface.GetSegmentsByProjectId.PaginatedResponse> => {
    return this.authenticatedClient
      .get<SegmentsInterface.GetSegmentsByProjectId.PaginatedResponse>('/segments', {
        params: {
          projectId: data.projectId,
          ...(data.index !== undefined ? { offset: data.index } : {}),
          ...(data.size !== undefined ? { limit: data.size } : {}),
          ...(data.sortBy !== undefined ? { sortBy: data.sortBy } : {}),
          ...(data.sortOrder !== undefined ? { sortOrder: data.sortOrder } : {}),
          ...(data.view !== undefined ? { view: data.view } : {}),
        },
      })
      .then((res) => res.data);
  };

  getSegmentById = (
    data: SegmentsInterface.GetSegmentById.Request
  ): Promise<SegmentsInterface.GetSegmentById.Response> => {
    return this.authenticatedClient
      .get<SegmentsInterface.GetSegmentById.Response>(`/segments/${data.segmentId}`)
      .then((res) => res.data);
  };

  getWidgetsByProjectId = (
    data: SegmentsInterface.GetWidgetsByProjectId.Request
  ): Promise<SegmentsInterface.GetWidgetsByProjectId.Response> => {
    return this.authenticatedClient
      .get<SegmentsInterface.GetWidgetsByProjectId.Response>('/segments/widgets', {
        params: { projectId: data.projectId },
      })
      .then((res) => res.data);
  };

  updateSegmentDashboard = (
    data: SegmentsInterface.UpdateSegmentDashboard.Request
  ): Promise<SegmentsInterface.UpdateSegmentDashboard.Response> => {
    return this.authenticatedClient
      .put<SegmentsInterface.UpdateSegmentDashboard.Response>(
        `/segments/${data.segmentId}/dashboard`,
        data.payload
      )
      .then((res) => res.data);
  };

  saveSegmentChartWidget = (
    data: SegmentsInterface.SaveSegmentChartWidget.Request
  ): Promise<SegmentsInterface.SaveSegmentChartWidget.Response> => {
    const { projectId, ...body } = data;
    return this.authenticatedClient
      .post<SegmentsInterface.SaveSegmentChartWidget.Response>('/segments/widget', {
        projectId,
        ...body,
      })
      .then((res) => res.data);
  };
}
